module.exports = __webpack_public_path__ + "static/media/Hero-DJ_AV.d0f5b8db.jpg";